import { render, staticRenderFns } from "./site-settings.vue?vue&type=template&id=6d7f86a4&"
import script from "./site-settings.vue?vue&type=script&lang=js&"
export * from "./site-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports